export default __webpack_public_path__ + "static/media/remove.4f9242b1.svg";